import { Component, OnInit, ViewChild } from '@angular/core';
import { OrderService } from '../../service/order.service';
import { InvoiceService } from '../../service/invoice.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Message } from 'primeng/components/common/api';
import { ReportService } from '../../service/report.service';
import { DatePipe } from '@angular/common/';
import { DataTable } from 'primeng/primeng';
import { UserService } from '../../shared/user.service';

@Component({
  selector: 'app-report-budget-utilization',
  templateUrl: './report-budget-utilization.component.html',
  styleUrls: ['./report-budget-utilization.component.css']
})
export class ReportBudgetUtilizationComponent implements OnInit {

  invoices: any[];
  cols = [
      //{ field: 'InvoiceType', header: 'סוג חשבונית', width: '100', priority: '' },
      { field: 'Catalog', header: 'מס קטלוגי', width: '80', priority: '' },
      { field: 'BudgetType', header: 'סוג תקציב', width: '80', priority: '' },
      { field: 'SupplierName', header: 'שם ספק', width: '80', priority: 'ui-p-6' },      
      { field: 'Category', header: 'קטגוריה', width: '80', priority: '' },
      { field: 'Destination', header: 'מספר יעד', width: '80', priority: '' },
      { field: 'InvoiceNumber', header: 'מספר חשבונית', width: '80', priority: '' },
      { field: 'InvoiceDate', header: 'תאריך חשבונית', width: '100', priority: 'ui-p-3' },
      { field: 'Description', header: 'פריט', width: '120', priority: '' },
      { field: 'Quantity', header: 'כמות', width: '60', priority: 'ui-p-6'   },
      { field: 'UnitePrice', header: 'מחיר ליחידה', width: '80', priority: 'ui-p-6'   },
      { field: 'Total', header: 'סה"כ מחיר', width: '80', priority: 'ui-p-6'   },
      { field: 'Tax', header: 'מע"מ', width: '70', priority: 'ui-p-6'   },
      { field: 'TotalWithTax', header: 'סה"כ מוזמן', width: '80', priority: 'ui-p-6' },
      { field: 'TotalWithTax', header: 'עלות בפועל', width: '80', priority: 'ui-p-6' },

      { field: 'InvoiceStatus', header: 'סטטוס חשבונית', width: '80', priority: 'ui-p-6' },
  ];

  treatmentTypes: any[] = [{value: '0', label: 'בכל שלבי טיפול'},{value: '1', label: 'ממתין לטיפולי'}];
  treatmentTypeSelected = this.treatmentTypes[0].value;

  filterOrderNumber: any;
  //filterSupplier: any;
  filterInvoiceNumber: any;
  filterInvoiceType: any;
  filterInvoiceStatus: any;
  filterDateFrom: any;
  filterDateTo: any;
  filterDestination: any;
  filterInvoiceLastPrint: any;

  selectedSuppliers: any;  //any[] = [];
  filteredSuppliers: any = [];  //any[] = [];

  filterLastSignDateFrom: any;
  filterLastSignDateTo: any;

  selectedConfirmer: any;
  confirmers: any[];

  //suppliersOptions: any[] = [];
  suppliers: any = [];

  invoiceStatusOptions: any[] = [];
  invoiceLastPrintOptions: any[] = [{ label: 'לא הודפס', value: '0' }, { label: 'הודפס', value: '1' }];

  msgs: Message[] = [];
  selectedCheckBox: any[];
  btnDialog: boolean = false;
  rowsTobeUpdated: any = null;
  @ViewChild('invoiceTable') dataTable: DataTable = null;
  flag: boolean;
  public userDetails: any;

  constructor(private orderService: OrderService, private invoiceService: InvoiceService, private reportService: ReportService, private datePipe: DatePipe, private userService: UserService) { }

  searchSuppliers(event) {
    let query = event.query;
    this.filteredSuppliers = this.filterSuppliers(query, this.suppliers);
  }

  ngOnInit() {
    this.userService.getUserClaims().subscribe((data: any) => {
      this.userDetails = data;
      //this.selectedConfirmer = this.userDetails.Id;
    },
    (err: HttpErrorResponse) => {
      this.userDetails = null;
    });

    this.filterOrderNumber = null;

    //this.filterSupplier = null;
    this.selectedSuppliers = null;
    this.orderService.GetCustomerSuppliers().subscribe((result: any) => {
      //this.suppliersOptions = result;
      this.suppliers = result;
    },
      (err: HttpErrorResponse) => {
        this.showMessage('error', '', 'תקלה בקבלת רשימת ספקים ');
    });

    this.selectedConfirmer = this.selectedConfirmer ? this.selectedConfirmer : null; //null;
    this.reportService.getPaymentConfirmersList().subscribe((result: any) => {
      //this.suppliersOptions = result;
      this.confirmers = result;
    },
      (err: HttpErrorResponse) => {
        this.showMessage('error', '', 'תקלה בקבלת רשימת מאשרים ');
    });

    this.filterInvoiceStatus = null;
    this.invoiceService.GetCustomerInvoiceStatuses().subscribe((result: any) => {
      this.invoiceStatusOptions = result;
      // this.invoiceStatusOptions.unshift({ label: 'הכל', value: null });

    },
      (err: HttpErrorResponse) => {
        this.showMessage('error', '', 'תקלה בקבלת רשימת סטטוסים ');
    });

    let fromD = new Date((new Date()).getFullYear(), 0, 1);
    this.filterDateFrom = new Date(Date.UTC(fromD.getFullYear(), fromD.getMonth(), fromD.getDate()));
    this.filterDateTo = new Date();

    this.filterInvoiceLastPrint = null;
    //this.invoiceLastPrintOptions.unshift({ label: 'לא הודפס', value: '0' }, { label: 'הודפס', value: '1' });
    //this.filterInvoiceLastPrint = '0';

    this.getCustomerInvoices();
  }

  getCustomerInvoices() {
    this.btnDialog = false;

    let invoiceFilter = {
      OrderNumber: this.filterOrderNumber,
      //SupplierId: this.filterSupplier ? this.filterSupplier.Id : null,
      SupplierId: this.selectedSuppliers ? this.selectedSuppliers.Id : null,
      InvoiceNumber: this.filterInvoiceNumber,
      InvoiceTypeId: 1, //this.filterInvoiceType,
      InvoiceStatusId: this.filterInvoiceStatus,
      InvoiceDateFrom: this.filterDateFrom ? new Date(Date.UTC(this.filterDateFrom.getFullYear(), this.filterDateFrom.getMonth(), this.filterDateFrom.getDate())) : null,
      InvoiceDateTo: this.filterDateTo ? new Date(Date.UTC(this.filterDateTo.getFullYear(), this.filterDateTo.getMonth(), this.filterDateTo.getDate())) : null,
      TreatmentType: this.treatmentTypeSelected,
      Destination: this.filterDestination,
      Confirmer: this.selectedConfirmer,
      LastSignDateFrom: this.filterLastSignDateFrom ? new Date(Date.UTC(this.filterLastSignDateFrom.getFullYear(), this.filterLastSignDateFrom.getMonth(), this.filterLastSignDateFrom.getDate())) : null,
      LastSignDateTo: this.filterLastSignDateTo ? new Date(Date.UTC(this.filterLastSignDateTo.getFullYear(), this.filterLastSignDateTo.getMonth(), this.filterLastSignDateTo.getDate())) : null,
      InvoiceLastPrint: this.filterInvoiceLastPrint
    };
    this.reportService.getReportCustomerInvoices(invoiceFilter).subscribe((result: any) => {
      this.invoices = result;
      this.invoices.forEach((item) => {
        item.InvoiceDate = this.datePipe.transform(item.InvoiceDate, 'dd/MM/yyyy')
      });
      if (this.invoices.length > 0) {
        let cnt = this.getCnt();
        if (cnt > 0) {
          //this.flag = true;
          this.flag = false;
          this.setCheckboxValuesInArray(this.flag);
        }
      }
    },
      (err: HttpErrorResponse) => {
        let errMessage = (err.error && err.error.ExceptionMessage) ? err.error.ExceptionMessage : 'תקלה בקבלת נתונים ';
        this.showMessage('error', '', errMessage);
      });
  }

  showMessage(type, summaryMessage, message): void {
    this.msgs = [];
    this.msgs.push({ severity: type, summary: summaryMessage, detail: message });
  }

  showSuccess() {
    this.msgs = [];
    this.msgs.push({ severity: 'success', summary: '', detail: ' העדכון נשמר בהצלחה' });
  }

  showError() {
    this.msgs = [];
    this.msgs.push({ severity: 'error', summary: '', detail: ' שגיאה בעדכון' });
  }

  setChecked(event: boolean, invoiceId: number): void {
    if (event) {
      let i = this.invoices.findIndex(i => i.InvoiceId === invoiceId);
      if (i != -1) {
        if (this.invoices[i].LastConfirmerUserId == this.userDetails.Id) {
          this.invoices[i].Check = true
        }
        else {
          this.invoices[i].Check = false
        }
      }
    }
    else {
      let i = this.invoices.findIndex(i => i.InvoiceId === invoiceId);
      if (i != -1)
        this.invoices[i].Check = false
    }
    this.setBtnDialog();
  }

  setBtnDialog(): void {
    let i = this.invoices.findIndex(i => i.Check === true);
    let cnt = this.invoices.filter(i => i.Check === true).length;
    if (i != -1 && cnt >= 1 && this.selectedSuppliers) { // && this.filterInvoiceStatus == '3') { // this.filterSupplier) { //2) {
      this.btnDialog = true;
    }
    else {
      this.btnDialog = false;
    }
  }

  printArray(): void {

    this.rowsTobeUpdated = 0;
    let DocumentLink = "CustomerPaymentOrder.pdf";
    this.invoices.forEach(element => {
      if (element.Check === true && (element.InvoiceId !== null || element.InvoiceId !== undefined)) {
        this.rowsTobeUpdated += 1;
        DocumentLink = "CustomerPaymentOrder." + element.SupplierId + ".pdf"
      }
    });
    let selectedInvoices = this.invoices.filter(i => (i.Check === true));
    try {
      this.reportService.printSelectedInvoices(selectedInvoices).subscribe(result => {
        window.URL.createObjectURL(new Blob([result], { type: 'application/octet-stream' }));
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(result, DocumentLink);
        }
        let url = window.URL.createObjectURL(result)
        let link = document.createElement('a');
        link.href = url;
        link.download = `${DocumentLink}`;
        link.click();
      },
        (err: HttpErrorResponse) => {
          let errMessage = (err.error && err.error.ExceptionMessage) ? err.error.ExceptionMessage : 'תקלה בהורדת קובץ ';
          this.showMessage('error', '', errMessage);
        });
    } catch (error) {
      this.showMessage('error', '', 'תקלה בהורדת הקובץ');
    }
    //this.cloneArray = {};
    //this.display = true;
  }

  getCnt(): number {
    let cnt = this.invoices.filter(i => (i.InvoiceId !== null || i.InvoiceId !== undefined)).length; //&& (i.MISPAR_MEZAHE_RESHUMA !== null || i.MISPAR_MEZAHE_RESHUMA !== "")).length;
    return cnt;
  }

  setCheckboxValuesInArray(event: boolean): void {
    if (event) {
      let filteredValueCnt: number = -1;
      // try {
      //   filteredValueCnt = this.dataTable.filteredValue.length;
      // } catch (error) {
      //   filteredValueCnt = -1;
      // }
      try {
        if (this.dataTable) {
          if (this.dataTable.filteredValue) {
            filteredValueCnt = this.dataTable.filteredValue.length;
          }
          else {
            filteredValueCnt = -1;
          }
        }
        else {
          filteredValueCnt = -1;
        }
      } catch (error) {
        filteredValueCnt = -1;
      }

      if (filteredValueCnt === -1) {
        for (let i = 0; i < this.invoices.length; i++) {
          let element = this.invoices[i];
          if ((element.InvoiceId)) {
            this.setChecked(true, element.InvoiceId);
            this.flag = true;
          }
        }
      }
      else if (filteredValueCnt > 0) {
        for (let i = 0; i < this.dataTable.filteredValue.length; i++) {
          let element = this.dataTable.filteredValue[i];
          if ((element.InvoiceId)) {
            this.setChecked(true, element.InvoiceId);
            this.flag = true;
          }
        }
      }
      else if (filteredValueCnt === 0) {
        this.flag = false;
        this.showMessage('info', '', 'לא נמצאו נתונים עבור הסינון שנבחר');
      }
    }
    else {
      for (let i = 0; i < this.invoices.length; i++) {
        let element = this.invoices[i];
        if ((element.InvoiceId)) {
          this.setChecked(false, element.InvoiceId);
          this.flag = false;
        }
      }
    }
  }

  onFilter(): void {
    this.setCheckboxValuesInArray(false);
    //this.setCheckboxValuesInArray(true);
  }

  filterSuppliers(query, suppliers: any[]): any[] {
    let filtered: any[] = [];
    for (let i = 0; i < suppliers.length; i++) {
      let supplier = suppliers[i];
      if (supplier.Name.toLowerCase().indexOf(query.toLowerCase()) >= 0 || supplier.EMail.toLowerCase().indexOf(query.toLowerCase()) >= 0) {
        filtered.push(supplier);
      }
    }
    return filtered;
  }

}



// WEBPACK FOOTER //
// C:/MyProjects_Git/GoDocu/GoDocuMng/Client/src/app/report/report-budget-utilization/report-budget-utilization.component.ts